
import { switchMap, mergeMap } from 'rxjs/operators'
import { empty, from, of } from 'rxjs'
import { combineEpics } from 'redux-observable'
import { Epic } from 'interfaces/middleware'
import { Store } from 'interfaces/state'
import { FLUSH_DATE_UPDATE, SETUP_FLUSH_DATE, flushDateUpdateActionCreator, confirmUpdatePopupActionCreator } from 'actions/flushDateActions'
import { flushDate$ } from 'helpers/observableAjaxHelpers'
import { resetFinancialStateActionCreator } from 'actions/globalActions'
import { isFeedPage } from 'helpers/feedHelpers'
import { Action } from 'actions'
import { pollLiveUpdateActionCreator } from 'actions/linkageActions'
import { byType } from 'rxOperators/byType'

const flushDateEpic: Epic = (action$, store: Store) =>
  action$
    .pipe(byType(FLUSH_DATE_UPDATE)).pipe(
      mergeMap(() => {
        const state = store.getState()
        const {
          backgroundFlush,
          prevBackgroundFlush,

          liveUpdateStarted,
          prevLiveUpdateStarted,
        } = state.data.flushDate

        const isBackgroundFlushChanged = backgroundFlush !== undefined && prevBackgroundFlush !== undefined && backgroundFlush !== prevBackgroundFlush
        const isLiveUpdateStarted = liveUpdateStarted !== undefined && prevLiveUpdateStarted !== undefined && liveUpdateStarted !== prevLiveUpdateStarted
        const actions: Action[] = []

        if (isBackgroundFlushChanged) {
          const isFeed = isFeedPage()
          if (isFeed) {
            actions.push(resetFinancialStateActionCreator())
          }

          actions.push(confirmUpdatePopupActionCreator({ isShown: true }))
        }

        if (isLiveUpdateStarted) {
          actions.push(pollLiveUpdateActionCreator.request({
            isRepeatedRequest: false,
            info: null,
          }))
        }

        if (actions.length === 0) {
          return empty()
        }

        return from(actions)
      }))

const setupFlushDateEpic: Epic = (action$, store: Store) =>
  action$
    .pipe(byType(SETUP_FLUSH_DATE)).pipe(
      switchMap(() => flushDate$),
      mergeMap((info) => {
        const state = store.getState()
        const { flushDate } = state.data
        if (flushDate.backgroundFlush !== info.last_background_flush_at || flushDate.liveUpdateStarted !== info.last_live_update_started_at) {
          return of(flushDateUpdateActionCreator(info))
        }
        return empty()
      }))


export default combineEpics(
  flushDateEpic,
  setupFlushDateEpic,
)
